module.exports = __webpack_public_path__ + "img/nosotros-home-min.2eca73f1.jpg";